import React, {
    useRef,
    useEffect,
    useState,
    forwardRef,
    useImperativeHandle,
  useMemo,
  } from "react";
  import SearchPanel from "../../../../../widgets/SearchPanel";
  import { fnGetDataSet } from "@shared/api/restApi";
  import { getInitFormData } from "@shared/utils/CommonUtils";
  import { global } from "@shared/libs/Global";
  import SnGrid from "@shared/components/GridV2/SnGrid";
  import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
  import { menuInfo } from "@shared/type/CommonType";

  interface Props {
    Menuprops: menuInfo;
  }
  
  const SN_MAS_SET_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const { userInfo } = global();
  
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitFormData({menuInfo : Menuprops,  etcInfo : {}});
          setFormData(rtn.formData);
          setFormControlData(rtn.formControlData);
          setColums({ grid1: rtn.grid.grid1 });
        } catch (error) {}
      };
      fetchform();
    }, []);
  
    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mas_set_rep_001_01",
          params: searchRef.current.getFormdata(),
        };
        const data: any = await fnGetDataSet( param);
        setDataSources({ grid1: data[0] });
      } catch (error) {
      }
    };
  
    useImperativeHandle(ref, () => ({
      onSearch,
    }));
  
    //#region useMemo
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
        },
      }),
      [columns, dataSources]
    );
    //#endregion

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            
          ></SearchPanel>
        </div>
        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "multiple",
              title: "시스템사용정보",
              isEditable: false,
            }}
          />
        </div>
      </div>
    );
  });
  
  export default SN_MAS_SET_REP_001;
  